import React from 'react'
import { Box, IcoMoon, TextInput, SearchIcon } from '@usap/uicomponents'

export default function TextInputWithIcon(props) {
  const {
    onChangeCB,
    placeholder,
    ariaLabel,
  } = props

  const placeholderVal = placeholder
    ? `Search by ${placeholder.toLowerCase()}`
    : ''
  const label = ariaLabel ? `Search by ${ariaLabel.toLowerCase()}` : ''

  return (
    <Box align="center">
      <Box
        width="large"
        direction="row"
        align="center"
        pad={{ horizontal: 'small' }}
        border={{ color: 'light-3', size: 'xsmall' }}
        round="4px"
      >
        <IcoMoon icon={SearchIcon} size="24px" color="dark-2" />
        <TextInput
          size="small"
          type="search"
          plain
          style={{
            fontSize: '14px',
            fontWeight: 'normal',
            height: '44px',
          }}
          onChange={event => onChangeCB(event.target.value)}
          placeholder={placeholderVal}
          aria-label={label}
        />
      </Box>
    </Box>
  )
}
